import type { AssetId, OutlookSpaceAssetId } from 'owa-timestream-types';

/**
 * A map between the resolved server generated asset ID and the client-generated asset ID. Useful when assets created during the
 * session have not updated the ID value in the asset array map, and server calls return only the resolved server ID of the asset
 */
export default new Map<OutlookSpaceAssetId, AssetId>();
